import { Skeleton } from "skullet/react";
import { SampleDogCard } from "./sample-dog-card";

export function ListingCardSkeletons({
    count,
    className,
    itemClassName,
}: {
    count: number;
    className: string;
    itemClassName?: string;
}) {
    return (
        <Skeleton loading>
            <div className={className}>
                {Array.from({ length: count }, (_, index) => (
                    <div key={index} className={itemClassName}>
                        <SampleDogCard />
                    </div>
                ))}
            </div>
        </Skeleton>
    );
}
